import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    modalShow: false,
    modalModifShow: false,

    list: [],

    ajoutOk: false,
    modifOk: false,

    current: [],

    listPrevendeur: [],
    listMarque: []
};

export const objectifSlice = createSlice({
    name: 'objectifData',

    initialState,

    reducers: {

        showmodal: (state, action) => {
            state.modalShow = action.payload;
        },

        modalModifShow: (state, action) => {
            state.modalModifShow = action.payload;
        },

        getList: (state, action) => {
            state.list = action.payload;
        },

        getPrevendeurList: (state, action) => {
            state.listPrevendeur = action.payload;
        },

        getMarqueList: (state, action) => {
            state.listMarque = action.payload;
        },

        current: (state, action) => {
            state.current = action.payload;
        },

        ajout: (state, action) => {
            state.ajoutOk = action.payload;
        },

        modif: (state, action) => {
            state.modifOk = action.payload;
        },

        addOne: (state, action) => {
            state.list.push(action.payload);
        },

        update: (state, action) => {

            const index = state.list.findIndex(
                element =>
                    element._id === action.payload._id
            );

            if (index !== -1) {
                state.list[index] = action.payload;
            }
        },

        remove: (state, action) => {

            state.list = state.list.filter(
                element =>
                    element._id !== action.payload
            );
        }
    }
});


export const {
    showmodal,
    modalModifShow,

    getList,
    getPrevendeurList,
    getMarqueList,

    current,

    ajout,
    modif,

    addOne,
    update,
    remove

} = objectifSlice.actions;


export default objectifSlice.reducer;